import React, { useEffect, useRef, useState } from "react";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import "./Notification.css";
import SearchIcon from "../assets/search.svg";
import Vector from "../assets/Vector.svg";
import TableContent from "./TableContent/TableContent";
import MultipleAssgin from "../modal/AssignNotify/MultipleAssgin";
import CreateAndUpdate from "../modal/CreateAndEditNotify/CreateAndUpdate";
import { AppDispatch, RootState } from "../../../redux-store/store";
import { useDispatch, useSelector } from "react-redux";
import { GetAllNotification_M3 } from "../../../api/notifyapi/Notifyapi";
import {
  getAssignUser,
  GetResources,
} from "../../../api/ssoapi/UserControlapi";
import { Pagination, Tooltip } from "antd";
import {
  IFilterModel,
  INotificationTableList,
  NotificationActions,
} from "../../../slices/NotificationSlice";
import FilterPopup from "../modal/CloumnFilter/FilterPopup";

import { ESearchFilterActiveTypes } from "../../../constants/CommonInterfaces";
import { DBTilte } from "../modal/CloumnFilter/ExtensiveFilterContent";

export interface INotificationTableActions {
  view: ITableRowActionField;
  edit: ITableRowActionField;
  assign: ITableRowActionField;
  recall: ITableRowActionField;
  delete: ITableRowActionField;
}

export interface ITableRowActionField {
  applicable: ETableRowActionFieldApplicable;
  message: string;
}

export enum ETableRowActionFieldApplicable {
  Show,
  Blur,
  Hide,
}

export interface IPage {
  pageSize: number;
  pageIndex: number;
}
const levelOption = [
  { label: "All", value: "ALL" },
  { label: "Level 1", value: "LEVEL_1" },
  { label: "Level 2", value: "LEVEL_2" },
];

const NotificationMangement: React.FC = () => {
  const { user, features } = useSelector((state: RootState) => state.user);
  const { selectedRowData, searchFilter, GlobalLevel, totalCount } =
    useSelector((state: RootState) => state.notification);

  const { apiQuery } = useSelector(
    (state: RootState) => state.notification.searchFilter
  );
  const { globalSearch } = useSelector(
    (state: RootState) => state.notification.searchFilter
  );

  const dispatch = useDispatch<AppDispatch>();
  const [isLevelOptionOpen, setIsLevelOptionOpen] = useState<boolean>(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const [isGlobalSearchActive, setIsGlobalSearchActive] =
    useState<boolean>(false);
  const [globalLevelSelect, setglobalLevelSelect] =
    useState<string>(GlobalLevel);
  const [isopenUpdateModal, setIsOpenUpdateModal] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [enableMultipleAssign, setEnableMultipleAssign] =
    useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<INotificationTableList[]>(
    []
  );

  useEffect(() => {
    performGetNotifyData();
  }, [
    globalLevelSelect,
    apiQuery.isPageChanged,
    apiQuery.isAscending,
    apiQuery.sortField,
  ]);

  const performGetNotifyData = () => {
    let lapiQuery = Object.assign({}, apiQuery);
    if (searchFilter.lastActiveSearch === ESearchFilterActiveTypes.global) {
      lapiQuery.filters = searchFilter.globalSearchApiQuery.filters;
      lapiQuery.isOr = searchFilter.globalSearchApiQuery.isOr;
    }

    dispatch(GetAllNotification_M3(lapiQuery));
  };

  useEffect(() => {
    const selectedRowsArray = Object.values(selectedRowData);
    setSelectedRows(selectedRowsArray);
  }, [selectedRowData]);

  // useEffect for user Update
  useEffect(() => {
    dispatch(NotificationActions.UpdateUser(user));
  }, [user]);

  // useEffect for Features Update
  useEffect(() => {
    dispatch(
      NotificationActions.UpdateNotificationFeatures(features.notification)
    );
  }, [features]);

  // Target Resource
  useEffect(() => {
    const fetchTargetResourcesData: any = async () => {
      try {
        await dispatch(GetResources());
      } catch (e) {}
    };
    fetchTargetResourcesData();
  }, []);

  // Function to handle option selection
  const handleLevelOptionToggle = () => {
    setIsLevelOptionOpen(!isLevelOptionOpen);
  };

  // Popup trigger for Create
  const handleCreateNotification = (): void => {
    setIsCreateModalOpen(!isCreateModalOpen);
  };

  // Popup trigger for Edit and update
  const handleOpenUpdate = (): void => {
    setIsOpenUpdateModal(!isopenUpdateModal);
  };

  // Popup trigger for multiple assign
  const handleMultipleAssign = (): void => {
    setEnableMultipleAssign(true);
    try {
      if (selectedRows.length > 0) {
        dispatch(getAssignUser(selectedRows[0].level));
      }
    } catch (error) {}
  };

  // popup trigger for close
  const handleMultipleAssignClose = (): void => {
    setEnableMultipleAssign(false);
  };

  // set the search query to search table content
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setIsGlobalSearchActive(false);
    dispatch(
      NotificationActions.UpdateGlobalSearchFilter({
        value: e.target.value,
      })
    );
  };

  // global search will affect after press the enter key
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      performGlobalSearch();
    }
  };

  // global search will affect after press the enter key
  const handleClickSearchIcon = (e: any) => {
    performGlobalSearch();
  };

  useEffect(() => {
    if (isGlobalSearchActive) {
      let lQuery: IFilterModel = {
        filters: searchFilter.globalSearchApiQuery.filters,
        isAscending: false,
        currentPageSize: searchFilter.apiQuery.currentPageSize,
        pageSize: searchFilter.apiQuery.pageSize,
        page: 1, //First time always get page 1
        isOr: true,
        isPageChanged: "",
        sortField: "",
      };
      dispatch(
        NotificationActions.UpdateLastActiveSearch({
          value: ESearchFilterActiveTypes.global,
        })
      );
      dispatch(
        NotificationActions.ResetColumnSearchFilter({
          canClearAll: true,
          fieldClear: "",
        })
      );
      dispatch(
        NotificationActions.resetLocalSearchQuery({
          canClearAll: true,
          fieldClear: "",
        })
      );
      dispatch(GetAllNotification_M3(lQuery));
      setIsGlobalSearchActive(false);
    }
  }, [isGlobalSearchActive]);

  const performGlobalSearch = () => {
    dispatch(
      NotificationActions.UpdateGlobalSearchApiQuery({
        value: globalSearch.value,
        needToSetActive: globalSearch.isActive,
        level: globalLevelSelect,
      })
    );
    dispatch(NotificationActions.UpdateGlobalSearchFilterActive());
    setIsGlobalSearchActive(true);
  };

  const paginationHandler = (page: number, pageSize: number) => {
    dispatch(
      NotificationActions.UpdatePagination({
        page: page,
        pageSize: pageSize,
        isPageChanged: true,
      })
    );
  };
  // set the global level search
  const handleGlobalLevelChange = (level: string): void => {
    setglobalLevelSelect(level);
    dispatch(NotificationActions.UpdateSetGlobalLevel(level));
    dispatch(
      NotificationActions.UpdateSearchQuery({
        field: DBTilte.level,
        operator: "eq",
        value: level,
      })
    );
    dispatch(
      NotificationActions.UpdateGlobalSearchApiQuery({
        level: level,
        needToSetActive: false,
        value: globalSearch.value,
      })
    );
    dispatch(
      NotificationActions.UpdatePagination({
        page: 1,
        pageSize: 10,
        isPageChanged: false,
      })
    );
    setIsLevelOptionOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        event.target instanceof Node &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsLevelOptionOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getAssignBtnState = (): ETableRowActionFieldApplicable => {
    if (!user || selectedRows.length === 0) {
      return ETableRowActionFieldApplicable.Blur;
    }
    if (selectedRows && selectedRows.length > 0) {
      return ETableRowActionFieldApplicable.Show;
    }

    return ETableRowActionFieldApplicable.Blur;
  };
  return (
    <div className="notification-main-container">
      <div style={{ height: "calc(100% - 30px)" }}>
        <div className="main-heading-container">
          <div className="main-heading">Notification Management</div>
          <div>
            <Tooltip
              title={
                getAssignBtnState() === ETableRowActionFieldApplicable.Blur
                  ? "Can't be perform"
                  : ""
              }
            >
              <button
                disabled={
                  getAssignBtnState() === ETableRowActionFieldApplicable.Blur
                    ? true
                    : false
                }
                className={`multiple-assign-btn ${
                  getAssignBtnState() === ETableRowActionFieldApplicable.Blur
                    ? " disabled-transparent-button-style"
                    : ""
                }`}
                onClick={() => handleMultipleAssign()}
              >
                Assign User
                <AssignmentIndOutlinedIcon
                  sx={{ fontSize: "20px", marginLeft: "5px" }}
                />
              </button>
            </Tooltip>
            {features.notification.createNotify && (
              <button
                className="create-button"
                onClick={handleCreateNotification}
                style={{ marginLeft: "25px" }}
              >
                Create Notification
              </button>
            )}
          </div>
        </div>
        <div className="options-container">
          <div className="options-subcontainer">
            <div className="select-option" ref={dropdownRef}>
              <button
                className="drop-down-button"
                onClick={handleLevelOptionToggle}
              >
                <span className="options-values">{globalLevelSelect}</span>
                <img src={Vector} alt="vector" />
              </button>
              {isLevelOptionOpen && (
                <div className="options">
                  {levelOption.map((level, index) => (
                    <div
                      key={index}
                      className="option"
                      onClick={() => handleGlobalLevelChange(level.value)}
                    >
                      {level.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {selectedRows.length > 0 && (
              <div className="selected-row-content">
                {selectedRows.length}{" "}
                <span className="selected-row-span">Selected</span>
              </div>
            )}
          </div>

          <div className="secondary-option-container">
            <div
              className={`search-container ${
                globalSearch.isActive ? " active-search-container" : ""
              }`}
            >
              <input
                type="search"
                placeholder="Search"
                value={searchFilter.globalSearch.value}
                name="search"
                autoComplete="off"
                className="input-element"
                onChange={(e) => handleSearchChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
              />

              <img
                src={SearchIcon}
                style={{ cursor: "pointer" }}
                alt="search"
                className="search-icon"
                onClick={handleClickSearchIcon}
              />
            </div>
            <div className="filter-container">
              <FilterPopup accessorKey="ExtensiveSearch" />
            </div>
          </div>
        </div>
        <div className="table-view-container">
          <TableContent isUpdate={handleOpenUpdate} />
        </div>

        {(isCreateModalOpen || isopenUpdateModal) && (
          <CreateAndUpdate
            isCreateClose={setIsCreateModalOpen}
            isUpdateClose={setIsOpenUpdateModal}
            EnableCreate={isCreateModalOpen}
          />
        )}
        {enableMultipleAssign ? (
          <MultipleAssgin
            data={selectedRows}
            onClose={handleMultipleAssignClose}
          />
        ) : (
          ""
        )}
      </div>
      {apiQuery.pageSize > 0 && (
        <div className="pagination-container">
          <Pagination
            size="small"
            align="start"
            current={apiQuery.page}
            pageSize={apiQuery.pageSize}
            total={totalCount}
            onChange={paginationHandler}
            showSizeChanger={false}
          />

          <div className="label-element">{`Showing ${
            (apiQuery.page - 1) * apiQuery.pageSize + 1
          } to ${
            (apiQuery.page - 1) * apiQuery.pageSize +
            1 +
            (apiQuery.currentPageSize - 1)
          } of ${totalCount} entries`}</div>
        </div>
      )}
    </div>
  );
};

export default NotificationMangement;
